import { type RouteObject } from "react-router-dom";

import { AUTH_ROLES } from "api/common/types/auth.types";
import SerialNumberTableContainer from "features/memberPortal/DocumentSerialManager/DocumentSerialManagerTable/SerialNumberTable.container";
import AuthenticatedRoute from "routing/AuthenticatedRoute";

const { NIAP } = AUTH_ROLES;

const quickLinksRoute: RouteObject[] = [
  {
    path: "document-serial-numbers",
    element: <AuthenticatedRoute allowedRoles={[NIAP]} />,

    children: [
      {
        index: true,
        element: <SerialNumberTableContainer />,
      },
    ],
  },
];

export default quickLinksRoute;
